var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMPrestamos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#2eccb6;}.cls-3{fill:none;}.cls-4{fill:#329be6;}.cls-5{fill:#0b5c96;}.cls-6{fill:#fff;}.cls-7{mix-blend-mode:multiply;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_prestamos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prestamos"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.72,32.72,46.9,13.9a14.27,14.27,0,0,1,.6,4.1,14.5,14.5,0,0,1-29,0,14.27,14.27,0,0,1,.6-4.1L.28,32.72a.4.4,0,0,0,0,.56L2.5,35.5v-.63a.39.39,0,0,1,.4-.4h8.2a.39.39,0,0,1,.4.4V44.5l2,2V35.19a.4.4,0,0,1,.34-.39l1.74-.3,4.55-.77A23,23,0,0,1,33.84,35.5h4.23a4.54,4.54,0,0,1,4.61,5.43l6.53-1.62a5,5,0,0,1,6.22,4.26L65.72,33.28A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "9 48 9 42 5 38 5 48 9 48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.1,4.1,33.28.28a.4.4,0,0,0-.56,0L28.9,4.1a14.31,14.31,0,0,1,8.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.8,54.32,18,51,32.72,65.72a.4.4,0,0,0,.56,0L49.09,49.91,34,54.31A.41.41,0,0,1,33.8,54.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37.1,4.1l9.8,9.8A14.56,14.56,0,0,0,37.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.1,13.9l9.8-9.8A14.56,14.56,0,0,0,19.1,13.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M33,32.5A14.51,14.51,0,0,0,47.5,18a14.27,14.27,0,0,0-.6-4.1L37.1,4.1a14.31,14.31,0,0,0-8.2,0l-9.8,9.8a14.27,14.27,0,0,0-.6,4.1A14.51,14.51,0,0,0,33,32.5ZM33,6A12,12,0,1,1,21,18,12,12,0,0,1,33,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M9,48H5V38L2.5,35.5V50.1a.4.4,0,0,0,.4.4h8.2a.4.4,0,0,0,.4-.4V44.5L9,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M11.5,34.87a.39.39,0,0,0-.4-.4H2.9a.39.39,0,0,0-.4.4v.63L5,38V37H9v5l2.5,2.5V34.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51.67,49.16A5.21,5.21,0,0,0,55.5,44a3.4,3.4,0,0,0-.07-.46l-6.34,6.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.5,48v1.71a.41.41,0,0,0,.32.39l1.66.35L18,51,13.5,46.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M50.43,39.16a5,5,0,0,0-1.22.15l-6.53,1.62a4.54,4.54,0,0,0-4.61-5.43H33.84a23,23,0,0,0-13.71-1.77l-4.55.77-1.74.3a.4.4,0,0,0-.34.39V46.5L18,51,33.8,54.32a.41.41,0,0,0,.19,0l15.1-4.4,6.34-6.34A5.06,5.06,0,0,0,50.43,39.16Zm.63,7.57-17.26,5L16,48V37l4.57-.78a20,20,0,0,1,3.62-.32A20.39,20.39,0,0,1,33.27,38h4.87a2.09,2.09,0,0,1,2.1,1.68,2,2,0,0,1-2,2.37h-8a1,1,0,1,0,0,2l7.53.6h.13l11.87-2.94a2.25,2.25,0,0,1,.62-.08A2.58,2.58,0,0,1,53,44.07,2.64,2.64,0,0,1,51.06,46.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M33,6A12,12,0,1,0,45,18,12,12,0,0,0,33,6Zm1.5,17.66v1.68a.67.67,0,0,1-.67.65h-2a.65.65,0,0,1-.65-.65V23.89a7.65,7.65,0,0,1-1.81-.52,1,1,0,0,1-.6-1.16l.17-.65a1,1,0,0,1,.52-.65,1.05,1.05,0,0,1,.78,0,5.73,5.73,0,0,0,2.24.43c.34,0,1.46-.05,1.46-.85,0-.45-.14-.79-1.73-1.33s-3.4-1.29-3.4-3.53a3.61,3.61,0,0,1,2.42-3.38V10.68a.65.65,0,0,1,.18-.47.6.6,0,0,1,.47-.2h2a.65.65,0,0,1,.65.65v1.41A4.16,4.16,0,0,1,36,12.4a1,1,0,0,1,.6,1.17l-.13.67a1.12,1.12,0,0,1-.52.63.85.85,0,0,1-.76,0,5.31,5.31,0,0,0-1.77-.3c-.82,0-1.29.36-1.29.77s.51.73,2,1.29c2.22.79,3.16,1.86,3.16,3.65A4.25,4.25,0,0,1,34.5,23.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.08,16.63c-1.48-.56-2-.89-2-1.29s.47-.77,1.29-.77a5.31,5.31,0,0,1,1.77.3.85.85,0,0,0,.76,0,1.12,1.12,0,0,0,.52-.63l.13-.67A1,1,0,0,0,36,12.4a4.16,4.16,0,0,0-1.39-.33V10.66a.65.65,0,0,0-.65-.65h-2a.6.6,0,0,0-.47.2.65.65,0,0,0-.18.47v1.57a3.61,3.61,0,0,0-2.42,3.38c0,2.24,1.81,3,3.4,3.53S34,20,34,20.49c0,.8-1.12.85-1.46.85a5.73,5.73,0,0,1-2.24-.43,1.05,1.05,0,0,0-.78,0,1,1,0,0,0-.52.65l-.17.65a1,1,0,0,0,.6,1.16,7.65,7.65,0,0,0,1.81.52v1.45a.65.65,0,0,0,.65.65h2a.67.67,0,0,0,.67-.65V23.66a4.25,4.25,0,0,0,2.74-3.38C37.24,18.49,36.3,17.42,34.08,16.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51.15,46.71l-17.35,5L16,48V37l4.57-.78A20.41,20.41,0,0,1,33.27,38h5a2,2,0,0,1,2,2h0a2,2,0,0,1-2,2h-8a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1l7.59.6,11.94-2.95a2.56,2.56,0,0,1,3.1,1.83h0A2.57,2.57,0,0,1,51.15,46.71Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 5,
    y: 36.97,
    width: 4.01,
    height: 11.03
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 66,
    height: 66
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMPrestamos);
export default __webpack_public_path__ + "static/media/m_prestamos.b90a75fbae0cefe44da165ba11a7cedf.svg";
export { ForwardRef as ReactComponent };